import NetworkingOperations from "../index";

const getMoneyAmounts = () => {
	const url = process.env.REACT_APP_GET_AMOUNTS;

	return NetworkingOperations.get({ url }).then((res) => res);
};

export default getMoneyAmounts;
